<div class="flex flex-col justify-between h-full">
  <!-- Form Content -->
  <div class="p-6" [formGroup]="form">
    <div class="flex flex-col gap-4">
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-6 lg:gap-x-12 gap-y-4">
        <!-- Row 1 -->
        <app-form-field label="Stop Type">
          <app-select
            formControlName="stopType"
            [options]="stopTypeOptions"
            placeholder="Select stop type"
          ></app-select>
        </app-form-field>

        <app-form-field label="Miles to Next Stop">
          <app-number-input
            formControlName="milesToNext"
            placeholder="e.g., 100"
            [showGrouping]="true"
            suffixText="miles"
          ></app-number-input>
        </app-form-field>
      </div>

      <!-- Appointment -->
      <app-form-card title="Appointment" icon="Clock">
        <div class="flex items-end gap-4 animate-fade-in">
          <app-appointment-control
            formControlName="appointment"
            orientation="vertical"
          ></app-appointment-control>
        </div>
      </app-form-card>

      <!-- Warehouse Details -->
      <app-form-card title="Warehouse Details" icon="MapPin">
        <div class="grid grid-cols-1 gap-x-6 lg:gap-x-12 gap-y-4">
          <!-- Row 1 -->
          <app-form-field label="Company Name">
            <app-input
              formControlName="companyName"
              placeholder="Enter company name"
            ></app-input>
          </app-form-field>

          <app-address-form formControlName="address"></app-address-form>
          <app-contact-input formControlName="contactInfo"></app-contact-input>
          <app-form-field label="Hours of Operation">
            <app-input
              formControlName="operatingHours"
              placeholder="e.g., M-F 9am - 5pm"
            ></app-input>
          </app-form-field>
        </div>
      </app-form-card>

      <!-- Weight & Reference Numbers & Item Counts -->
      <app-form-card title="Stop-Level Product Details" icon="package">
        <div
          class="grid grid-cols-1 md:grid-cols-2 gap-x-6 lg:gap-x-12 gap-y-4"
        >
          <app-form-field label="Stop-Level Reference Numbers">
            <app-key-value-array-input
              formControlName="referenceNumbers"
              addButtonLabel="Add Reference"
              [keys]="referenceTypes"
            ></app-key-value-array-input>
          </app-form-field>

          <app-form-field label="Stop-Level Item Counts">
            <app-key-value-array-input
              formControlName="itemCounts"
              addButtonLabel="Add Item Count"
              [keys]="itemTypes"
            ></app-key-value-array-input>
          </app-form-field>

          <app-form-field label="Weight (lbs)">
            <app-number-input
              formControlName="weight"
              placeholder="0"
              [showGrouping]="true"
              suffixText="lbs"
            ></app-number-input>
          </app-form-field>

          <app-form-field label="Weight Ticket">
            <app-number-input
              formControlName="weightTicket"
              placeholder="Enter ticket"
            ></app-number-input>
          </app-form-field>

          <app-form-field label="Seal Number">
            <app-input
              formControlName="sealNumber"
              placeholder="Enter seal"
            ></app-input>
          </app-form-field>

          @if (load.trailerType === 'REEFER' || load.trailerType === 'REEFER_TEAM') {
            <app-form-field label="Reefer Temperature">
              <app-number-input
                formControlName="reeferTemp"
                placeholder="e.g., -10"
                suffixText="°F"
              ></app-number-input>
            </app-form-field>
          }
        </div>
      </app-form-card>
      <!-- Instructions & Notes -->
      <app-form-card title="Stop-Level Instructions & Notes" icon="package">
        <div class="grid grid-cols-1 gap-x-6 lg:gap-x-12 gap-y-4">
          <app-form-field label="Driver Instructions" class="mt-0">
            <app-textarea
              formControlName="instructions"
              placeholder="Add instructions..."
              [rows]="4"
            ></app-textarea>
          </app-form-field>
          <app-form-field label="Other Notes" class="mt-0">
            <app-textarea
              formControlName="notes"
              placeholder="Add notes..."
              [rows]="4"
            ></app-textarea>
          </app-form-field>
        </div>
      </app-form-card>
    </div>
  </div>
  <!-- Modal Actions -->
  <div
    class="flex flex-col-reverse lg:flex-row justify-end gap-3 p-2 md:p-4 border-t border-border"
  >
    <app-button variant="secondary" (click)="cancel()" [disabled]="isSaving()">
      Cancel
    </app-button>
    <app-button
      (click)="save()"
      [disabled]="form.invalid || isSaving()"
      [loading]="isSaving()"
    >
      {{ isSaving() ? "Saving..." : "Save Changes" }}
    </app-button>
  </div>
</div>
